import { useSelector, useDispatch } from "react-redux";
import { Button, Tooltip } from "@mui/material";
import { BookingNotAvailable } from "../../../../redux/reducers/HotelPortalReducer";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import cloneDeep from "lodash/cloneDeep";

interface IAvailabilityProps {
  rowParams: any;
}

export default function Availability(props: IAvailabilityProps): JSX.Element {
  const { rowParams } = props;
  const dispatch = useDispatch();
  const hotelBookings: any = useSelector((state: IRootState) => state.hotelBookings.hotelBookings);
  const fetchingThunk = useSelector((state: IRootState) => state.hotelBookings.fetchingThunk);
  const noHotelAvailability = (avail: boolean, temp_id: string, hotelId: string): void => {
    const bookingDetail = hotelBookings.find((booking: any) => {
      return booking.temp_id === temp_id;
    });
    if (bookingDetail) {
      const availBooking = cloneDeep(bookingDetail);
      availBooking.noHotelAvailability = avail;
      if (availBooking.hasOwnProperty("_id") && availBooking._id === "") {
        delete availBooking._id;
      }
      dispatch(
        BookingNotAvailable({
          booking: availBooking,
          hotelIDs: [hotelId],
        })
      );
    }
  };
  return (
    <>
      {!rowParams.noHotelAvailability && (
        <Tooltip title="Mark As Not Availiable">
          <>
            <Button
              disabled={
                (rowParams.statusName !== "additions" &&
                  rowParams.statusName !== "modifications" &&
                  rowParams.statusName !== "noChanges") ||
                fetchingThunk
              }
              sx={{ color: "white" }}
              color="warning"
              onClick={() => noHotelAvailability(true, rowParams.temp_id, rowParams.hotel_id)}
            >
              <DoDisturbOnIcon sx={{ fontSize: "14px" }} />
            </Button>
          </>
        </Tooltip>
      )}
      {rowParams.noHotelAvailability && (
        <Tooltip title="Remove No Availability">
          <>
            <Button
              disabled={
                (rowParams.statusName !== "additions" &&
                  rowParams.statusName !== "modifications" &&
                  rowParams.statusName !== "noChanges") ||
                fetchingThunk
              }
              sx={{ color: "white", fontSize: "10px" }}
              color="warning"
              onClick={() => noHotelAvailability(false, rowParams.temp_id, rowParams.hotel_id)}
            >
              <EventAvailableIcon sx={{ fontSize: "14px" }} />
            </Button>
          </>
        </Tooltip>
      )}
    </>
  );
}
